import React, { useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip as RechartTooltip, Legend as RechartLegend } from 'recharts';
import TabSwitcher from "../components/tabSwitcher";
import LegendInfo from "../components/legendInfo";
import LoadingBarChart from "../components/loadingBarChart";
import pieColorsDE from "../components/pieColorsDE";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChartSwitcherPreview = ({ loading = true, data = [], active = false }) => {
    const [activeTab, setActiveTab] = useState('firmenprojekte');

    const firmenprojekteData = data.map(item => ({
        name: item.Status,
        value: parseFloat(item.Anzahl)
    }));

    const mitarbeiterData = data.map(item => ({
        name: item.Status,
        value: parseFloat(item.Mitarbeiter)
    }));

    const sumFirmenprojekteData = firmenprojekteData.reduce((acc, item) => acc + item.value, 0);
    const sumMitarbeiterData = mitarbeiterData.reduce((acc, item) => acc + item.value, 0);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-60 w-full">
                <LoadingBarChart />
            </div>
        );
    }

    const selectedData = activeTab === 'firmenprojekte' ? firmenprojekteData : mitarbeiterData;
    const total = activeTab === 'firmenprojekte' ? sumFirmenprojekteData : sumMitarbeiterData;

    return (
        <div className="flex flex-col items-center justify-center w-full">
            <h2 className="font-semibold text-xl mb-4">Info</h2>
            <TabSwitcher activeTab={activeTab} onTabChange={setActiveTab} />
            <div className="flex flex-row items-center w-full">
                <div className="w-2/3" style={{ height: '280px' }}>
                    <ResponsiveContainer>
                        <PieChart>
                            <Pie
                                data={selectedData}
                                dataKey="value"
                                nameKey="name"
                                outerRadius={100}
                            >
                                {selectedData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={pieColorsDE[entry.name]} />
                                ))}
                            </Pie>
                            <RechartTooltip />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                <LegendInfo gesamt={total} className={'w-1/3 ml-4 text-left'} textSize={"text-sm"} />
            </div>
        </div>
    );
};

export default PieChartSwitcherPreview;
